/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
/** TalentHunt */

/** YRF MAIN DEV*/
// export const b2cPolicies = {
//     names: {
//         signUpSignIn: 'B2C_1_YRF_Casting_App',
//         forgotPassword: 'B2C_1_reset_v3',
//         editProfile: 'B2C_1_edit_profile_v2',
//     },
//     authorities: {
//         signUpSignIn: {
//             authority: 'https://yrfcastingappdev.b2clogin.com/yrfcastingappdev.onmicrosoft.com/B2C_1_YRF_Casting_App',
//         },
//         forgotPassword: {
//             authority: 'https://yrfcastingappdev.b2clogin.com/yrfcastingappdev.onmicrosoft.com/B2C_1_YRF_Casting_App',
//         },
//         editProfile: {
//             authority: 'https://yrfcastingappdev.b2clogin.com/yrfcastingappdev.onmicrosoft.com/b2c_1_edit_profile_v2',
//         },
//     },
//     authorityDomain: 'yrfcastingappdev.b2clogin.com',
// };

/** YRF MAIN NEW UAT*/
export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1_YRF_Casting__UAT_App",
    forgotPassword: "B2C_1_reset_v3",
    editProfile: "B2C_1_edit_profile_v2",
  },
  authorities: {
    signUpSignIn: {
      authority: `https://prodluvfilmscasting.ciamlogin.com/${process.env.REACT_APP_TENANT_ID_PROD}`,
    },
  },
  // authorityDomain: "prodluvfilmscasting.ciamlogin.com",
};

/** YRF MAIN PROD*/
// export const b2cPolicies = {
//     names: {
//         signUpSignIn: 'B2C_1_YRF_Casting_PROD_App',
//         forgotPassword: 'B2C_1_reset_v3',
//         editProfile: 'B2C_1_edit_profile_v2',
//     },
//     authorities: {
//         signUpSignIn: {
//             authority: 'https://yrfcastingappb2cprod.b2clogin.com/yrfcastingappb2cprod.onmicrosoft.com/B2C_1_YRF_Casting_PROD_App',
//         },
//         forgotPassword: {
//             authority: 'https://yrfcastingappb2cprod.b2clogin.com/yrfcastingappb2cprod.onmicrosoft.com/B2C_1_YRF_Casting_PROD_App',
//         },
//         editProfile: {
//             authority: 'https://yrfcastingappb2cprod.b2clogin.com/yrfcastingappb2cprod.onmicrosoft.com/b2c_1_edit_profile_v2',
//         },
//     },
//     authorityDomain: 'yrfcastingappb2cprod.b2clogin.com',
// };

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    // clientId: process.env.REACT_APP_CLIENT_ID_DEV, // This is the ONLY mandatory field that you need to supply. // YRF MAIN DEV-- ClientId
    // clientId: process.env.REACT_APP_CLIENT_ID_UAT, // This is the ONLY mandatory field that you need to supply. // YRF MAIN NEW UAT-- ClientId
    clientId: process.env.REACT_APP_CLIENT_ID_PROD, // This is the ONLY mandatory field that you need to supply. // YRF MAIN NEW PROD-- ClientId
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
    knownAuthorities: ["prodluvfilmscasting.ciamlogin.com"], // Mark your B2C tenant's domain as trusted.
    // redirectUri: "http://localhost:3000/", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    // postLogoutRedirectUri: "http://localhost:3000/web", // Indicates the page to navigate after logout.

    redirectUri: "https://casting.luvfilms.in/", // Uncomment this line for production new   ---YRF MAIN PROD
    postLogoutRedirectUri: "https://casting.luvfilms.in/web", // Uncomment this line for production new   ---YRF MAIN PROD

    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  // http://localhost:44347/
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**YRF MAIN DEV*/
// export const storageAccountName = process.env.REACT_APP_STORAGE_ACCOUNT_NAME_DEV;
// export const containerName = process.env.REACT_APP_STORAGE_CONTAINER_NAME_DEV;
// export const containerFileName = process.env.REACT_APP_STORAGE_CONTAINER_FILE_NAME_DEV;
// export const sasToken = process.env.REACT_APP_STORAGE_SAS_TOKEN_DEV;

/**YRF MAIN UAT Expiry - 2025-09-05*/
export const storageAccountName =
  process.env.REACT_APP_STORAGE_ACCOUNT_NAME_UAT;
export const containerName = process.env.REACT_APP_STORAGE_CONTAINER_NAME_UAT;
export const containerFileName =
  process.env.REACT_APP_STORAGE_CONTAINER_FILE_NAME_UAT;
export const sasToken = process.env.REACT_APP_STORAGE_SAS_TOKEN_UAT;

/**YRF MAIN PROD Expiry - 2025-09-06*/
// export const storageAccountName = process.env.REACT_APP_STORAGE_ACCOUNT_NAME_PROD;
// export const containerName = process.env.REACT_APP_STORAGE_CONTAINER_NAME_PROD;
// export const containerFileName = process.env.REACT_APP_STORAGE_CONTAINER_FILE_NAME_PROD;
// export const sasToken = process.env.REACT_APP_STORAGE_SAS_TOKEN_PROD;

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  apiTodoList: {
    endpoint: "http://localhost:3000/",
    scopes: {
      // read: ['https://graph.microsoft.com/openid'],
      // read: ['https://yrfcastingappdev.onmicrosoft.com/c65018d4-8911-4ebb-9b25-c20cc119403a/tasks.read'],     //YRF MAIN DEV
      read: [
        "https://yrfcastingappdev.onmicrosoft.com/dd17cccb-dc5e-4d2c-a00e-74a69b3cf760/tasks.read",
      ], //YRF MAIN UAT
      // read: ['https://yrfcastingappb2cprod.onmicrosoft.com/fc224a18-0ffa-4918-b4cc-e5a8e97e359b/tasks.read'],     //YRF MAIN PROD
      // write: ['https://talenthuntb2c.onmicrosoft.com/TodoList/ToDoList.ReadWrite'],
      // write: ['https://yrfcastingappdev.onmicrosoft.com/c65018d4-8911-4ebb-9b25-c20cc119403a/tasks.ReadWrite']   //YRF MAIN DEV
      write: [
        "https://yrfcastingappdev.onmicrosoft.com/dd17cccb-dc5e-4d2c-a00e-74a69b3cf760/tasks.ReadWrite",
      ], //YRF MAIN UAT
      // write: ['https://yrfcastingappb2cprod.onmicrosoft.com/fc224a18-0ffa-4918-b4cc-e5a8e97e359b/tasks.ReadWrite']   //YRF MAIN PROD
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  // scopes: [...protectedResources.apiTodoList.scopes.read],
  scopes: [
    // ...protectedResources.apiTodoList.scopes.read,
    // ...protectedResources.apiTodoList.scopes.write,
  ],
  // scope: 'openid profile',
};
